import styled, { keyframes } from "styled-components";
import logoLapieza from "../../assets/logo-lapieza.png";
import { palette, fonts } from "../../styles/palette";

// Animación de carga
export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingOverlayContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 4000;
  background: ${palette.overlayWhite};
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-width: 100vw;

  &::before {
    content: "";
    position: absolute;
    top: 24px;
    left: 24px;
    width: 150px;
    height: 34px;
    background: url(${logoLapieza}) no-repeat left center / contain;
    pointer-events: none;
    z-index: 5000;
  }
`;

export const LoadingSpinner = styled.div`
  width: 80px;
  height: 80px;
  border: 4px solid ${palette.gray};
  border-top: 4px solid ${palette.red};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 24px;
`;

export const LoadingText = styled.div`
  font-family: ${fonts.heading};
  font-size: 24px;
  font-weight: 600;
  color: ${palette.navy};
  text-align: center;
  margin-bottom: 8px;
`;

export const LoadingSubtext = styled.div`
  font-size: 16px;
  color: ${palette.textSecondary};
  text-align: center;
  max-width: 300px;
  line-height: 1.5;
`;
